import { checkResponse, parseJSONDate } from "src/components/js/statics1";

export function gridSetting_getX_fromH(gridSettings, hour) {
  const x = hour * gridSettings.hour_width + gridSettings.vehicles_width;
  return x;
}

let posXSumAllCache;
let unitWidthHInCache = {};
export function gridSetting_getPerc_fromH(gridSettings, hoursFromTime0) {
  const cacheKey = `${gridSettings.keikkaFirstHour}_${gridSettings.keikkaLastHour}_${gridSettings.timeParts}_${hoursFromTime0}`;

  if (!posXSumAllCache || posXSumAllCache.cacheKey !== cacheKey) {
    posXSumAllCache = {
      cacheKey: cacheKey,
      value: getUnitWidthFromH(gridSettings, gridSettings.totalhours),
    };
  }

  // If the result is in the cache, return it
  if (unitWidthHInCache[cacheKey] !== undefined) {
    //return unitWidthHInCache[cacheKey];
  }

  const posXUnits = getUnitWidthFromH(gridSettings, hoursFromTime0);
  let proc2 = (posXUnits / posXSumAllCache.value) * 100;
  // Store the result in the cache before returning it
  unitWidthHInCache[cacheKey] = proc2;
  return proc2;
}

function getUnitWidthFromH(gridSettings, hoursFromTime0) {
  const a = gridSettings.kloInactiveHoursWidth_Units; // 0
  const b = gridSettings.kloActiveHoursWidth_Units; // 30
  const c = gridSettings.kloInactiveHoursWithKeikkaWidth_Units; // 15

  const timePartsFromTime0 = hoursFromTime0 * gridSettings.timeParts;
  let posXUnits = 0;
  for (let _minute = 0; _minute <= timePartsFromTime0; _minute++) {
    let addAmount = 0;
    const _timePart = _minute / gridSettings.timeParts;
    if (_timePart <= gridSettings.activeHourStart || _timePart > gridSettings.activeHourEnd)
      addAmount = a;
    else addAmount = b;
    if (gridSettings.keikkaFirstHour > 0) {
      if (_timePart < gridSettings.activeHourStart && _timePart > gridSettings.keikkaFirstHour)
        addAmount = c;
      else if (_timePart > gridSettings.activeHourEnd && _timePart <= gridSettings.keikkaLastHour)
        addAmount = c;
    }
    posXUnits += addAmount;
  }
  let adj = 0;
  if (hoursFromTime0 < 0) return (adj = -6000);
  if (hoursFromTime0 > gridSettings.totalhours) adj = 6000;

  return posXUnits + adj;
}

export function gridSettings_getPerc_fromTime(gridSettings, keikkaTime, selectedGridStartTime) {
  let hoursFromTime0 = (keikkaTime - selectedGridStartTime) / 1000 / 60 / 60;
  // round to 2 decimals
  hoursFromTime0 = Math.round(hoursFromTime0 * 100) / 100;
  const perc = gridSetting_getPerc_fromH(gridSettings, hoursFromTime0);
  return perc;
}

// filter by startDate, endDate
export async function gridSettings_listKeikkas(
  personId,
  token,
  startDate,
  endDate,
  ownerAsiakasId = null
) {
  startDate.setHours(0, 0, 0, 0); // set to 00:00:00
  endDate.setHours(23, 59, 59, 999); // set to 23:59:59

  if (personId === 0) return;
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        personId: personId,
        startDate: startDate,
        endDate: endDate,
        ownerAsiakasId: ownerAsiakasId,
      }),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/grid/keikkas/list",
      requestOptions
    );
    const cResponse = await checkResponse(
      response,
      "gridSettingsFunctions.js:gridSettings_listKeikkas"
    );
    // loop _newVehicles and fix firstDate and lastDate
    for (let i = 0; i < cResponse?.data?.ajoneuvot?.length || 0; i++) {
      const v = cResponse.data.ajoneuvot[i];
      v.firstDate = parseJSONDate(v.firstDate);
      v.lastDate = parseJSONDate(v.lastDate);
    }
    return cResponse;
  } catch (err) {
    console.log(err);
    return { success: false, errorMessage: err.message, data: [] };
  }
}
